var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.792,
    height: 70,
    viewBox: "0 0 64.792 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#584237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e5042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e614b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80523d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-helping_hand",
    transform: "translate(-6 -4.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    "data-name": "Path 4055",
    d: "M58.194,22.4,31.2,17,20.4,27.8,6,29.6,6,58.4H58.194Z",
    transform: "translate(0 10.398)",
    fill: "#654c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    "data-name": "Path 4056",
    d: "M32.6,24.5A4.5,4.5,0,0,0,37.1,29h9a4.5,4.5,0,0,0,4.5-4.5h0A4.5,4.5,0,0,0,46.1,20h-9a4.5,4.5,0,0,0-4.5,4.5Zm1.8,9A4.5,4.5,0,0,0,38.9,38h9a4.5,4.5,0,0,0,4.5-4.5h0A4.5,4.5,0,0,0,47.9,29h-9a4.5,4.5,0,0,0-4.5,4.5Zm-1.8,9A4.5,4.5,0,0,0,37.1,47h9a4.5,4.5,0,0,0,4.5-4.5h0A4.5,4.5,0,0,0,46.1,38h-9a4.5,4.5,0,0,0-4.5,4.5Zm-3.6,9A4.5,4.5,0,0,0,33.5,56h9A4.5,4.5,0,0,0,47,51.5h0A4.5,4.5,0,0,0,42.5,47h-9A4.5,4.5,0,0,0,29,51.5Z",
    transform: "translate(18.395 12.797)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693",
    transform: "translate(54.594 41.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M43.8,25H36.6a1.8,1.8,0,1,0,0,3.6Zm0,9H36.6a1.8,1.8,0,0,0,0,3.6Zm-3.6,9H34.8a1.8,1.8,0,1,0,0,3.6Z",
    transform: "translate(-33 -25)",
    fill: "#3c2d25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694",
    transform: "translate(22.089 3.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_55",
    "data-name": "Union 55",
    d: "M27.224,65.7A4.424,4.424,0,0,1,22.685,70a4.422,4.422,0,0,1-4.534-4.3V63.54a4.544,4.544,0,0,1,9.075,0v0a4.543,4.543,0,0,1,9.073,0V65.7a4.543,4.543,0,0,1-9.073,0Zm-18.146,0,0-2.158a4.43,4.43,0,0,1,4.537-4.307,4.426,4.426,0,0,1,4.537,4.309V65.7A4.422,4.422,0,0,1,13.612,70,4.421,4.421,0,0,1,9.077,65.7ZM0,65.7V63.54a4.429,4.429,0,0,1,4.539-4.307,4.427,4.427,0,0,1,4.536,4.309V65.7A4.423,4.423,0,0,1,4.539,70,4.423,4.423,0,0,1,0,65.7ZM1.659,44.955l-.566-.745a1.734,1.734,0,0,1,.065-2.166L3.847,38.8a11.638,11.638,0,0,0,2.447-5.12l.967-10.349L9.78,18.537c1.482-3.207,3.376-5.427,6.554-5.972,0,0,3.629,0,7.259-5.385L27.224,0,49,16.152,44.028,27.665l-.473,1.052H20.1L16.85,35.674a22.787,22.787,0,0,1-7.485,8.679L7.815,45.5a5.155,5.155,0,0,1-2.941.866A3.921,3.921,0,0,1,1.659,44.955Z",
    transform: "translate(-0.302 0.323)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(24 65.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    "data-name": "Path 4060",
    d: "M43,40.52a2.7,2.7,0,0,1,5.4.054c-.016,1.406-5.414,1.35-5.4-.054m-18,0a2.7,2.7,0,0,1,5.4.054c-.016,1.406-5.414,1.35-5.4-.054m-9,0a2.7,2.7,0,0,1,5.4.054c-.016,1.406-5.414,1.35-5.4-.054m18,0a2.7,2.7,0,0,1,5.4.054c-.016,1.406-5.414,1.35-5.4-.054",
    transform: "translate(-16.001 -38)",
    fill: "#ffcdd2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.6ae5befaba4989092b3b97639866b6cc.svg";
export { ForwardRef as ReactComponent };